var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.922,
    height: 15.922,
    viewBox: "0 0 15.922 15.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-log-out",
    "data-name": "Icon feather-log-out",
    transform: "translate(-3.75 -3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_483",
    "data-name": "Caminho 483",
    d: "M9.307,18.922H6.1a1.6,1.6,0,0,1-1.6-1.6V6.1A1.6,1.6,0,0,1,6.1,4.5h3.2",
    fill: "none",
    stroke: "#6e857c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_484",
    "data-name": "Caminho 484",
    d: "M24,18.512l4.006-4.006L24,10.5",
    transform: "translate(-9.084 -2.795)",
    fill: "none",
    stroke: "#6e857c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_485",
    "data-name": "Caminho 485",
    d: "M23.115,18H13.5",
    transform: "translate(-4.193 -6.289)",
    fill: "none",
    stroke: "#6e857c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.3bac4dd1ee4ae20fb6affd21d6ee204d.svg";
export { ForwardRef as ReactComponent };